module.exports = __webpack_public_path__ + "images/Garden-061357f3ca28fc4e850a0dce6d0917a6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/Garden.jpg
// module id = 23
// module chunks = 0